










































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getProperties } from '@/api/properties'
import Pagination from '@/components/Pagination/index.vue'
import PropertyItem from '@/views/search/components/PropertyItem.vue'
import {
  createFilter,
  FilterOperator,
  FilterType, getSortItems,
  prepareListFilters
} from '@/utils/filter'
import { hasPermission } from '@/utils'
import { redirectToEdit, redirectToSite } from '@/utils/property'

@Component({
  name: 'BridgeEvents',
  components: {
    Pagination,
    PropertyItem
  }
})

export default class extends Vue {
  @Prop({ required: true }) private client!: any
  private total = 0
  private list = []
  private listLoading = false
  private listQuery = createFilter()
  private hasPermission = hasPermission
  private redirectToSite = redirectToSite
  private redirectToEdit = redirectToEdit

  created() {
    this.getList()
  }

  private prepareFilters() {
    prepareListFilters({
      listQuery: this.listQuery,
      withDefaultSort: true,
      search: '',
      searchFields: [],
      filters: [],
      callback: () => {
        this.listQuery.query?.filters?.items?.push({
          type: FilterType.field,
          key: 'client_id',
          value: this.client.id,
          operator: FilterOperator.eq
        })
      }
    })
  }

  private handleSortChange(params: any = {}) {
    if (this.listQuery?.query?.sort) {
      this.listQuery.query.sort = getSortItems(params)
    }
    this.getList()
  }

  private async getList() {
    this.listLoading = true
    try {
      this.prepareFilters()
      const { data } = await getProperties(this.listQuery)
      this.list = data.collection || []
      this.total = data.pagination.total_items || 0
    } catch (err) {}
    this.listLoading = false
  }
}
